import { setAccountStoreInitialized } from '../actions/internalActions';
import { AccountProviderType, addOWAConnectedAccount } from 'owa-accounts-store';
import { initializeOwaAccountsStore } from '../actions/publicActions';
import {
    ConnectedAccountResponse,
    lazyGetAllConnectedAccounts,
    OAuthProviderType,
} from 'owa-link-account';
import { orchestrator } from 'satcheljs';
import { addSeconds, now } from 'owa-datetime';
import { assertNever } from 'owa-assert';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getOWAConnectedAccountStoreState } from '../selectors/getOWAConnectedAccountStoreState';
/**
 * This orchestrator is triggered from calendar module initializeState.
 * It looks up the existing connected accounts in the server.
 */
orchestrator(initializeOwaAccountsStore, async () => {
    if (getOWAConnectedAccountStoreState() === true) {
        return;
    }
    const response = await lazyGetAllConnectedAccounts.importAndExecute();

    const connectedAccounts = response as ConnectedAccountResponse[];
    if (connectedAccounts) {
        connectedAccounts.filter(isSupportedConnectedAccount).forEach(account => {
            const tokenExpiration = parseInt(account.token.expiresIn);
            addOWAConnectedAccount({
                primarySmtpAddress: account.userAccount.emailAddress,
                displayEmail: account.userAccount.emailAddress,
                accountId: account.userAccount.id,
                accountUniqueId: account.userAccount.accountUniqueId,
                anchorMailbox: account.userAccount.routingHint,
                token: account.token.accessToken,
                tokenExpiry: addSeconds(now(), tokenExpiration),
                accountProviderType: getAccountProviderType(account.providerType),
                isAccountValid: tokenExpiration > 0,
            });
        });
    }

    setAccountStoreInitialized(true);
});

function isSupportedConnectedAccount(connectedAccount: ConnectedAccountResponse): boolean {
    switch (connectedAccount.providerType) {
        case OAuthProviderType.Msa:
        case OAuthProviderType.MsaInt:
            return true;
        case OAuthProviderType.Google:
            return isFeatureEnabled('cal-addCalendar-google');
        case OAuthProviderType.TeamSnap:
            return false;
        default:
            return assertNever(connectedAccount.providerType as never);
    }
}

function getAccountProviderType(providerType: OAuthProviderType): AccountProviderType {
    switch (providerType) {
        case OAuthProviderType.Msa:
            return 'Outlook';
        case OAuthProviderType.Google:
            return 'Google';
        default:
            return assertNever(providerType as never);
    }
}
